// Module
var code = "<span class=\"inverse-condition-wrapper\"> <input data-bind=\"uniform: Value, checked: Value\" type=\"checkbox\"> </span> ";
// Exports
export default code;